import { FooterContainer } from "./footer.styles";
import wormhole from "../../assets/wormhole2.webp";

const Footer = () => {
  return (
    <FooterContainer>
      <p>
        Please check out my GitHub profile for more information
        about public projects I have worked on
      </p>

      <a
        href="https://github.com/Sanja969?tab=repositories"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          style={{
            borderRadius: "150px",
            backgroundColor: "transparent",
            filter: "drop-shadow(0 0 12px #30fffe)",
            transition: "0.3s ease",
          }}
          src={wormhole}
          alt="wormhole"
          width={85}
        />
      </a>

      <h6>Copyright © Sanja969</h6>
    </FooterContainer>
  );
};

export default Footer;